<template>
  <header class="header">
    <section class="header__section">
      <h1 class="header__section--title">
        <router-link :to="{ path: `/${langPath}company/summary` }">
          <img
            src="../../../assets/images/logo.svg"
            class="margin-right12"
            alt="TMF VIRTUAL RUN TOKYO MARATHON FOUNDATION"
            width="295"
            height="42"
          />
        </router-link>
      </h1>
      <div class="header__section--block">
        <button type="button" @click="onLogout" class="logout-button">{{
          headerJson.logout[lang]
        }}</button>
        <!--        <router-link-->
        <!--          :to="{ path: `/${langPath}company/confirmation` }"-->
        <!--          class="confirm-link flex-all-center"-->
        <!--        >-->
        <!--          {{ headerJson.oauth[lang] }}-->
        <!--        </router-link>-->
        <!-- ログイン画面時は英語切り替えを表示しない -->
        <ul
          class="header__section--block__list"
          v-if="
            !$route.path.includes('confirmation') ||
            !$route.path.includes('login')
          "
        >
          <li class="list-item" :class="{ active: isJaActive }">
            <a :href="`/${switchLangPath}`" class="link flex-all-center">
              JP
            </a>
          </li>
          <li class="list-item" :class="{ active: isEnActive }">
            <a :href="`/en/${switchLangPath}`" class="link flex-all-center">
              EN
            </a>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
import header from "../../../assets/constants/header.json";
import cognito from "../../../plugins/cognito";
export default {
  data() {
    return {
      isJaActive: this.$route.path.split("/")[1] !== "en",
      isEnActive: this.$route.path.split("/")[1] === "en",
      switchLangPath:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.fullPath.split("/").slice(2).join("/")
          : this.$route.fullPath.split("/").slice(1).join("/"),
    };
  },
  methods: {
    onLogout: function () {
      if (!confirm("ログアウトしますか")) return;
      cognito.logout();
      this.$router.push("/company/login");
    },
  },
  computed: {
    headerJson: function () {
      return header;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "CompanyHeader",
};
</script>

<style scoped lang="scss">
.header {
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
  position: relative;
  &::before {
    content: "";
    display: block;
    height: 5px;
    background: url("../../../assets/images/border/border_header_pc.svg") center;
  }
  &__section {
    padding: 21px 0 22px 0;
    width: 1000px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    /*productionでビルドした時だけvuetifyのスタイルが優先されてしまうため*/
    &--title {
      margin: 0;
    }

    &--block {
      display: flex;

      .confirm-link {
        width: 240px;
        height: 30px;
        border: solid 1px var(--defaultBlackColor);
        font-weight: bold;
        &:hover {
          color: var(--defaultWhiteColor);
          background-color: var(--defaultBlackColor);
        }
      }

      .logout-button {
        margin: 0 30px 0 0;
        width: 180px;
        height: 30px;
        border: solid 1px var(--defaultBlackColor);
        font-weight: bold;
        &:hover {
          color: var(--defaultWhiteColor);
          background-color: var(--defaultBlackColor);
        }
      }
      &__list {
        display: flex;
        margin: 0 0 0 30px;
        padding: 0 0 0 30px;
        border-left: solid 1px #000;

        .list-item {
          width: 30px;
          height: 30px;
          border: solid 1px #000;
          font-size: 18px;
          font-weight: bold;

          .link {
            width: 100%;
            height: 100%;
          }

          &:hover {
            background-color: #000;
            .link {
              color: #fff;
            }
          }

          &:not(:first-of-type) {
            margin: 0 0 0 5px;
          }
        }

        .active {
          background-color: #000;

          .link {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/company/CompanyHeader.vue